import React from 'react';

import { DndContext, DragEndEvent } from '@dnd-kit/core';
import { SortableContext, arrayMove } from '@dnd-kit/sortable';

import { Alert, Box, Stack, Typography } from '@mui/material';

import { Experiences } from '@luxuryescapes/contract-svc-experience';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import { CuratedListItem } from './CuratedListItem';

type ContentProps = {
  selectedExperiences: Array<Experiences.Offer>;
  onRemoveExperience: (experience: Experiences.Offer) => void;
  onLoadSelectedExperiences: (experiences: Array<Experiences.Offer>) => void;
};

function CuratedList({ selectedExperiences, onRemoveExperience, onLoadSelectedExperiences }: ContentProps) {
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (active?.id !== over?.id) {
      const oldIndex = selectedExperiences.findIndex((item) => item.id === active.id);
      const newIndex = selectedExperiences.findIndex((item) => item.id === over.id);

      if (oldIndex !== -1 && newIndex !== -1) {
        onLoadSelectedExperiences(arrayMove(selectedExperiences, oldIndex, newIndex));
      }
    }
  };

  return (
    <Box>
      <PageSubheader title="Curated list"></PageSubheader>
      <Box>
        <Stack direction="column" spacing={2} marginTop={2}>
          {selectedExperiences.length > 2 && (
            <Alert severity="warning" style={{ textAlign: 'center' }}>
              In the <strong>hotel flow</strong>, only the 2 best offers in this list will be available on{' '}
              <strong>In-Flow</strong>.
            </Alert>
          )}
          {selectedExperiences.length ? (
            <DndContext onDragEnd={handleDragEnd}>
              <SortableContext items={selectedExperiences}>
                <Stack direction="column" spacing={1}>
                  {selectedExperiences.map((value) => {
                    return (
                      <CuratedListItem key={`item-${value.id}`} removeOnclick={onRemoveExperience} value={value} />
                    );
                  })}
                </Stack>
              </SortableContext>
            </DndContext>
          ) : (
            <Typography>No experiences have been added yet</Typography>
          )}
        </Stack>
      </Box>
    </Box>
  );
}

export default CuratedList;
